import type { ContractorTranslation } from './en';

export const de: ContractorTranslation = {
  common: {
    cancel: 'Abbrechen',
    save: 'Speichern',
    retry: 'Erneut versuchen',
    download: 'Herunterladen',
    continue: 'Weiter',
    yes: 'Ja',
    no: 'Nein',
    genericError: 'Etwas ist schiefgelaufen. Bitte versuch es noch einmal.',
    networkError: 'DubForge ist nicht erreichbar. Prüf deine Internetverbindung.',
  },
  app: {
    tagline: 'Synchronaufträge, Dateien und Feedback an einem Ort.',
    startupFailed: 'DubForge konnte nicht gestartet werden',
    notFoundTitle: 'Seite nicht gefunden',
    notFoundBody: 'Diese Seite gibt es nicht oder du hast keinen Zugriff darauf.',
    goHome: 'Zur Startseite',
    crashTitle: 'Etwas ist schiefgelaufen',
    crashBody: 'Lade die Seite bitte neu.',
    reload: 'Neu laden',
  },
  language: {
    label: 'Sprache',
    change: 'Sprache ändern',
  },
  welcome: {
    title: 'Willkommen bei DubForge',
    body: 'Wähle deine Sprache. DubForge und deine Discord-Benachrichtigungen verwenden sie.',
    changeLater: 'Du kannst sie jederzeit über das Sprachmenü oben rechts ändern.',
  },
  nav: {
    myAssignments: 'Meine Aufträge',
    openMenu: 'Menü öffnen',
    account: 'Konto',
    notificationEmail: 'E-Mail für Benachrichtigungen',
    signOut: 'Abmelden',
    roleAdmin: 'Admin',
    roleContractor: 'Sprecher:in',
    lightMode: 'Heller Modus',
    darkMode: 'Dunkler Modus',
  },
  login: {
    signIn: 'Mit Discord anmelden',
    onlyInvited: 'Nur Discord-Konten, die vom Kanalinhaber hinzugefügt wurden, können sich anmelden.',
    signingIn: 'Du wirst angemeldet…',
    backToSignIn: 'Zurück zur Anmeldung',
    failed: 'Anmeldung fehlgeschlagen. Bitte versuch es noch einmal.',
  },
  authErrors: {
    not_invited:
      'Dieses Discord-Konto wurde nicht zu DubForge hinzugefügt. Bitte den Kanalinhaber, dich hinzuzufügen.',
    access_off: 'Dein Zugang zu DubForge wurde deaktiviert.',
    discord_only: 'Du kannst dich nur mit Discord anmelden.',
  },
  errors: {
    not_signed_in: 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
    access_off: 'Dein Zugang zu DubForge wurde deaktiviert.',
    admins_only: 'Dazu hast du keine Berechtigung.',
    not_found: 'Dieses Element gibt es nicht oder es ist nicht mehr verfügbar.',
    invalid_request: 'Etwas an dieser Anfrage ist ungültig. Bitte prüf es und versuch es noch einmal.',
    conflict: 'Das gibt es bereits.',
    already_approved: 'Dieser Auftrag wurde bereits freigegeben, weitere Uploads sind nicht nötig.',
    not_audio: 'Es können nur WAV- oder MP3-Dateien hochgeladen werden. Lade nur deine Sprachspur hoch.',
    upload_incomplete: 'Der Upload wurde nicht abgeschlossen. Bitte versuch es noch einmal.',
    discord_unreachable: 'Discord ist nicht erreichbar. Bitte versuch es später noch einmal.',
    server_error: 'Bei uns ist etwas schiefgelaufen. Bitte versuch es noch einmal.',
  },
  notifications: {
    title: 'Benachrichtigungen',
    openWithCount: 'Benachrichtigungen ({{count}} ungelesen)',
    markAllRead: 'Alle als gelesen markieren',
    empty: 'Noch nichts da.',
  },
  emailSettings: {
    body: 'Wir schicken dir eine E-Mail, wenn du einen neuen Auftrag bekommst und wenn deine Arbeit geprüft wurde.',
    label: 'E-Mail-Adresse',
    fromDiscord: 'Aus deinem Discord-Konto übernommen. Ändere sie, wenn du eine andere Adresse möchtest.',
    saved: 'E-Mail-Adresse gespeichert',
    invalid: 'Gib eine gültige E-Mail-Adresse ein.',
    missing: 'Noch keine E-Mail-Adresse. Füge eine hinzu, um Benachrichtigungen zu erhalten.',
  },
  status: {
    Assigned: 'Zugewiesen',
    InProgress: 'In Arbeit',
    Submitted: 'Wartet auf Prüfung',
    ChangesRequested: 'Änderungen angefordert',
    Approved: 'Freigegeben',
  },
  assetKind: {
    package: 'Synchronpaket (Video + Stimme + SFX)',
    video: 'Referenzvideo (720p)',
    sfx: 'SFX-/Musikspur',
    voice: 'Originale Sprachspur',
    script: 'Skript',
    other: 'Sonstiges',
  },
  translation: {
    machine: 'Maschinell übersetzt',
    showOriginal: 'Original anzeigen',
    showTranslation: 'Übersetzung anzeigen',
  },
  uploader: {
    progress: '{{percent}} % von {{size}}',
    queued: 'Wartet auf Upload: {{count}}',
    keepOpen: 'Lass diesen Tab geöffnet, bis der Upload fertig ist.',
    cancelled: 'Upload abgebrochen',
    done: '{{name}} hochgeladen',
    failed: 'Upload fehlgeschlagen: {{error}}',
  },
  my: {
    greeting: 'Hallo {{name}}',
    subtitle: 'Deine Synchronaufträge.',
    emptyTitle: 'Noch keine Aufträge',
    emptyBody: 'Sobald du ein Video bekommst, erhältst du eine Nachricht auf Discord und es erscheint hier.',
    todo: 'Zu erledigen',
    waiting: 'Wartet auf Prüfung',
    done: 'Erledigt',
    updated: 'Aktualisiert {{when}}',
  },
  assignment: {
    back: 'Meine Aufträge',
    dubIn: 'Synchronisation: {{language}}',
    paid: 'Bezahlt',
    next: {
      Assigned: 'Lade die Quelldateien herunter, nimm deine Stimme auf und lade dann hier deine Sprachspur hoch.',
      InProgress: 'Sobald deine Sprachspur fertig ist, lade sie unten hoch.',
      Submitted:
        'Deine Synchronisation wurde zur Prüfung eingereicht. Du bekommst eine Nachricht auf Discord, sobald sie geprüft wurde.',
      ChangesRequested: 'Es wurden Änderungen angefordert. Lies das Feedback unten und lade dann eine neue Version hoch.',
      Approved: 'Freigegeben. Danke!',
    },
    notes: 'Hinweise',
    sourceFiles: 'Quelldateien',
    noFiles: 'Es wurden noch keine Dateien hochgeladen.',
    fileInfo: '{{kind}} · {{size}}',
    packageHint: 'Eine .mp4-Datei mit dem Video und zwei Tonspuren: Spur 1 enthält die Originalstimmen, Spur 2 die SFX.',
    uploadTitle: 'Lade deine Sprachspur hoch',
    voiceOnlyTitle: 'Nur deine Stimme',
    voiceOnlyBody:
      'Lade nur deine aufgenommene Stimme hoch: keine Musik, keine Soundeffekte und nichts vom Originalton. Achte darauf, dass sie genauso lang ist wie das Original.',
    voiceOnlyConfirm: 'Diese Datei enthält nur Sprachaufnahmen.',
    dropLabel: 'Sprachspur hier hochladen',
    dropHint: 'Nur WAV oder MP3.',
    noteForReviewer: 'Hinweis für die Prüfung (optional)',
    lengthTitle: 'Die Länge stimmt nicht überein',
    lengthBody:
      'Deine Datei ist {{dub}} lang, die SFX-Spur aber {{sfx}}. Wenn deine Spur an einer anderen Stelle beginnt oder abgeschnitten ist, ist sie nicht synchron zum Video. Trotzdem hochladen?',
    uploadAnyway: 'Trotzdem hochladen',
    chooseAnother: 'Andere Datei wählen',
    versions: 'Hochgeladene Versionen',
    nothingUploaded: 'Noch nichts hochgeladen.',
    version: 'Version {{version}}',
    reviewApproved: 'Freigegeben',
    reviewChanges: 'Änderungen angefordert',
    reviewPending: 'Wartet auf Prüfung',
    yourNote: 'Dein Hinweis:',
    feedback: 'Feedback',
    listen: 'Anhören',
    uploadedOn: '{{date}} · {{size}}',
    length: 'Länge: {{duration}}',
  },
};
